import _ from 'lodash'
import type {DecorationSingleComponentPluginFunction} from '../../types'
import type {ComponentExportStructure} from '@wix/document-services-types'
import {ORIGINAL_PATH_TO_PACKED, STYLE_DATA_PATH, URL_PARAM_TO_PATH, WPHOTO_CUSTOM_DESIGN_TYPE} from './constants'
import {packToQueryParams} from '../../utils/urlParams'
import {moveFields} from '../../utils/mapFields'

export const pack: DecorationSingleComponentPluginFunction = (component: ComponentExportStructure) => {
    moveFields(component, ORIGINAL_PATH_TO_PACKED)

    if (!_.isEmpty(_.get(component, STYLE_DATA_PATH))) {
        _.set(component, [...STYLE_DATA_PATH.split('.'), 'type'], WPHOTO_CUSTOM_DESIGN_TYPE)
    }
    component.src = packToQueryParams(component, 'src', _.invert(URL_PARAM_TO_PATH))
}
